// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/requestcatalog/v1/requestcatalog.proto" (package "c1.api.requestcatalog.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { RequestCatalogSearchService } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest } from "./requestcatalog";
import type { RequestCatalogSearchServiceEntitlementCountByAppResponse } from "./requestcatalog";
import type { RequestCatalogSearchServiceEntitlementCountByAppRequest } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest } from "./requestcatalog";
import type { RequestCatalogSearchServiceListBrowsableAppsInBundleResponse } from "./requestcatalog";
import type { RequestCatalogSearchServiceListBrowsableAppsInBundleRequest } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest } from "./requestcatalog";
import type { SearchAppResourcesInCatalogResponse } from "./requestcatalog";
import type { SearchAppResourcesInCatalogRequest } from "./requestcatalog";
import type { SearchRequestCatalogBundlesResponse } from "./requestcatalog";
import type { SearchRequestCatalogBundlesRequest } from "./requestcatalog";
import type { AppEntitlementsInCatalogTermsResponse } from "./requestcatalog";
import type { AppEntitlementsInCatalogTermsRequest } from "./requestcatalog";
import type { CountUsersLosingMembershipResponse } from "./requestcatalog";
import type { CountUsersLosingMembershipRequest } from "./requestcatalog";
import type { SearchRemovedUsersResponse } from "./requestcatalog";
import type { SearchRemovedUsersRequest } from "./requestcatalog";
import type { SearchAppEntitlementsInCatalogResponse } from "./requestcatalog";
import type { SearchAppEntitlementsInCatalogRequest } from "./requestcatalog";
import type { AccessRequestUrlManagerServiceGenerateResponse } from "./requestcatalog";
import type { AccessRequestUrlManagerServiceGenerateRequest } from "./requestcatalog";
import type { AccessRequestUrlManagerServiceResponse } from "./requestcatalog";
import type { AccessRequestUrlManagerServiceRequest } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchAppResourcesCountResponse } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchAppResourcesCountRequest } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchBrowsableAppsResponse } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchBrowsableAppsRequest } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchResourcesPerAppResponse } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchResourcesPerAppRequest } from "./requestcatalog";
import type { GetAppEntitlementWithRequestCatalogsResponse } from "./requestcatalog";
import type { GetAppEntitlementWithRequestCatalogsRequest } from "./requestcatalog";
import type { SearchAppEntitlementsWithRequestCatalogsResponse } from "./requestcatalog";
import type { SearchAppEntitlementsWithRequestCatalogsRequest } from "./requestcatalog";
import type { SearchRequestCatalogsWithEnrollmentCountsResponse } from "./requestcatalog";
import type { SearchRequestCatalogsWithEnrollmentCountsRequest } from "./requestcatalog";
import type { SearchRequestCatalogsResponse } from "./requestcatalog";
import type { SearchRequestCatalogsRequest } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchResourceTypesPerAppResponse } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchResourceTypesPerAppRequest } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchTasksForResourcesResponse } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchTasksForResourcesRequest } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchEntitlementsForUserResponse } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchEntitlementsForUserRequest } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchEntitlementsPerAppResponse } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchEntitlementsPerAppRequest } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest } from "./requestcatalog";
import type { AccessProfileMembershipResponse } from "./requestcatalog";
import type { AccessProfileMembershipRequest } from "./requestcatalog";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { RequestCatalogSearchServiceSearchEntitlementsResponse } from "./requestcatalog";
import type { RequestCatalogSearchServiceSearchEntitlementsRequest } from "./requestcatalog";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.requestcatalog.v1.RequestCatalogSearchService
 */
export interface IRequestCatalogSearchServiceClient {
    /**
     * Search request catalogs based on filters specified in the request body.
     *
     * @generated from protobuf rpc: SearchEntitlements
     */
    searchEntitlements(input: RequestCatalogSearchServiceSearchEntitlementsRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchEntitlementsRequest, RequestCatalogSearchServiceSearchEntitlementsResponse>;
    /**
     * Search for access profiles with enrolled members
     *
     * @generated from protobuf rpc: SearchAccessProfileMemberships
     */
    searchAccessProfileMemberships(input: AccessProfileMembershipRequest, options?: RpcOptions): UnaryCall<AccessProfileMembershipRequest, AccessProfileMembershipResponse>;
    /**
     * @generated from protobuf rpc: SearchAppsWithGrantStatus
     */
    searchAppsWithGrantStatus(input: RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest, RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse>;
    /**
     * @generated from protobuf rpc: SearchEntitlementsPerApp
     */
    searchEntitlementsPerApp(input: RequestCatalogSearchServiceSearchEntitlementsPerAppRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchEntitlementsPerAppRequest, RequestCatalogSearchServiceSearchEntitlementsPerAppResponse>;
    /**
     * @generated from protobuf rpc: SearchCatalogEntitlementsPerApp
     */
    searchCatalogEntitlementsPerApp(input: RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest, RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse>;
    /**
     * @generated from protobuf rpc: SearchEntitlementsForUser
     */
    searchEntitlementsForUser(input: RequestCatalogSearchServiceSearchEntitlementsForUserRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchEntitlementsForUserRequest, RequestCatalogSearchServiceSearchEntitlementsForUserResponse>;
    /**
     * @generated from protobuf rpc: SearchTasksForResources
     */
    searchTasksForResources(input: RequestCatalogSearchServiceSearchTasksForResourcesRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchTasksForResourcesRequest, RequestCatalogSearchServiceSearchTasksForResourcesResponse>;
    /**
     * @generated from protobuf rpc: SearchResourceTypesPerApp
     */
    searchResourceTypesPerApp(input: RequestCatalogSearchServiceSearchResourceTypesPerAppRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchResourceTypesPerAppRequest, RequestCatalogSearchServiceSearchResourceTypesPerAppResponse>;
    /**
     * @generated from protobuf rpc: SearchAccessEntitlementsPerApp
     */
    searchAccessEntitlementsPerApp(input: RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest, RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse>;
    /**
     * @generated from protobuf rpc: SearchRequestCatalogs
     */
    searchRequestCatalogs(input: SearchRequestCatalogsRequest, options?: RpcOptions): UnaryCall<SearchRequestCatalogsRequest, SearchRequestCatalogsResponse>;
    /**
     * @generated from protobuf rpc: SearchRequestCatalogsWithEnrollmentCounts
     */
    searchRequestCatalogsWithEnrollmentCounts(input: SearchRequestCatalogsWithEnrollmentCountsRequest, options?: RpcOptions): UnaryCall<SearchRequestCatalogsWithEnrollmentCountsRequest, SearchRequestCatalogsWithEnrollmentCountsResponse>;
    /**
     * @generated from protobuf rpc: SearchAppEntitlementsWithRequestCatalogs
     */
    searchAppEntitlementsWithRequestCatalogs(input: SearchAppEntitlementsWithRequestCatalogsRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementsWithRequestCatalogsRequest, SearchAppEntitlementsWithRequestCatalogsResponse>;
    /**
     * @generated from protobuf rpc: GetAppEntitlementWithRequestCatalogs
     */
    getAppEntitlementWithRequestCatalogs(input: GetAppEntitlementWithRequestCatalogsRequest, options?: RpcOptions): UnaryCall<GetAppEntitlementWithRequestCatalogsRequest, GetAppEntitlementWithRequestCatalogsResponse>;
    /**
     * @generated from protobuf rpc: SearchResourcesPerApp
     */
    searchResourcesPerApp(input: RequestCatalogSearchServiceSearchResourcesPerAppRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchResourcesPerAppRequest, RequestCatalogSearchServiceSearchResourcesPerAppResponse>;
    /**
     * @generated from protobuf rpc: SearchBrowsableApps
     */
    searchBrowsableApps(input: RequestCatalogSearchServiceSearchBrowsableAppsRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchBrowsableAppsRequest, RequestCatalogSearchServiceSearchBrowsableAppsResponse>;
    /**
     * @generated from protobuf rpc: SearchBrowsableAppResources
     */
    searchBrowsableAppResources(input: RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest, RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse>;
    /**
     * @generated from protobuf rpc: SearchAppResourcesCount
     */
    searchAppResourcesCount(input: RequestCatalogSearchServiceSearchAppResourcesCountRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchAppResourcesCountRequest, RequestCatalogSearchServiceSearchAppResourcesCountResponse>;
    /**
     * @generated from protobuf rpc: ParseAccessRequestToken
     */
    parseAccessRequestToken(input: AccessRequestUrlManagerServiceRequest, options?: RpcOptions): UnaryCall<AccessRequestUrlManagerServiceRequest, AccessRequestUrlManagerServiceResponse>;
    /**
     * @generated from protobuf rpc: GenerateAccessRequestToken
     */
    generateAccessRequestToken(input: AccessRequestUrlManagerServiceGenerateRequest, options?: RpcOptions): UnaryCall<AccessRequestUrlManagerServiceGenerateRequest, AccessRequestUrlManagerServiceGenerateResponse>;
    /**
     * @generated from protobuf rpc: SearchAppEntitlementsInCatalog
     */
    searchAppEntitlementsInCatalog(input: SearchAppEntitlementsInCatalogRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementsInCatalogRequest, SearchAppEntitlementsInCatalogResponse>;
    /**
     * @generated from protobuf rpc: SearchRemovedUsers
     */
    searchRemovedUsers(input: SearchRemovedUsersRequest, options?: RpcOptions): UnaryCall<SearchRemovedUsersRequest, SearchRemovedUsersResponse>;
    /**
     * @generated from protobuf rpc: CountUsersLosingMembership
     */
    countUsersLosingMembership(input: CountUsersLosingMembershipRequest, options?: RpcOptions): UnaryCall<CountUsersLosingMembershipRequest, CountUsersLosingMembershipResponse>;
    /**
     * @generated from protobuf rpc: GetSearchTerms
     */
    getSearchTerms(input: AppEntitlementsInCatalogTermsRequest, options?: RpcOptions): UnaryCall<AppEntitlementsInCatalogTermsRequest, AppEntitlementsInCatalogTermsResponse>;
    /**
     * @generated from protobuf rpc: SearchRequestCatalogBundles
     */
    searchRequestCatalogBundles(input: SearchRequestCatalogBundlesRequest, options?: RpcOptions): UnaryCall<SearchRequestCatalogBundlesRequest, SearchRequestCatalogBundlesResponse>;
    /**
     * @generated from protobuf rpc: SearchAppResourcesInCatalog
     */
    searchAppResourcesInCatalog(input: SearchAppResourcesInCatalogRequest, options?: RpcOptions): UnaryCall<SearchAppResourcesInCatalogRequest, SearchAppResourcesInCatalogResponse>;
    /**
     * @generated from protobuf rpc: SearchBrowsableAppsInBundle
     */
    searchBrowsableAppsInBundle(input: RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest, RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse>;
    /**
     * @generated from protobuf rpc: ListBrowsableAppsInBundle
     */
    listBrowsableAppsInBundle(input: RequestCatalogSearchServiceListBrowsableAppsInBundleRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceListBrowsableAppsInBundleRequest, RequestCatalogSearchServiceListBrowsableAppsInBundleResponse>;
    /**
     * @generated from protobuf rpc: SearchCatalogEnrollmentsCount
     */
    searchCatalogEnrollmentsCount(input: RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest, RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse>;
    /**
     * @generated from protobuf rpc: SearchBrowsableAppEntitlementsCount
     */
    searchBrowsableAppEntitlementsCount(input: RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest, RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse>;
    /**
     * @generated from protobuf rpc: SearchCatalogEntitlementCountByApp
     */
    searchCatalogEntitlementCountByApp(input: RequestCatalogSearchServiceEntitlementCountByAppRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceEntitlementCountByAppRequest, RequestCatalogSearchServiceEntitlementCountByAppResponse>;
    /**
     * @generated from protobuf rpc: SearchCatalogAccessEntitlements
     */
    searchCatalogAccessEntitlements(input: RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest, RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse>;
}
/**
 * @generated from protobuf service c1.api.requestcatalog.v1.RequestCatalogSearchService
 */
export class RequestCatalogSearchServiceClient implements IRequestCatalogSearchServiceClient, ServiceInfo {
    typeName = RequestCatalogSearchService.typeName;
    methods = RequestCatalogSearchService.methods;
    options = RequestCatalogSearchService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Search request catalogs based on filters specified in the request body.
     *
     * @generated from protobuf rpc: SearchEntitlements
     */
    searchEntitlements(input: RequestCatalogSearchServiceSearchEntitlementsRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchEntitlementsRequest, RequestCatalogSearchServiceSearchEntitlementsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogSearchServiceSearchEntitlementsRequest, RequestCatalogSearchServiceSearchEntitlementsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Search for access profiles with enrolled members
     *
     * @generated from protobuf rpc: SearchAccessProfileMemberships
     */
    searchAccessProfileMemberships(input: AccessProfileMembershipRequest, options?: RpcOptions): UnaryCall<AccessProfileMembershipRequest, AccessProfileMembershipResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessProfileMembershipRequest, AccessProfileMembershipResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppsWithGrantStatus
     */
    searchAppsWithGrantStatus(input: RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest, RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest, RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchEntitlementsPerApp
     */
    searchEntitlementsPerApp(input: RequestCatalogSearchServiceSearchEntitlementsPerAppRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchEntitlementsPerAppRequest, RequestCatalogSearchServiceSearchEntitlementsPerAppResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogSearchServiceSearchEntitlementsPerAppRequest, RequestCatalogSearchServiceSearchEntitlementsPerAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchCatalogEntitlementsPerApp
     */
    searchCatalogEntitlementsPerApp(input: RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest, RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest, RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchEntitlementsForUser
     */
    searchEntitlementsForUser(input: RequestCatalogSearchServiceSearchEntitlementsForUserRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchEntitlementsForUserRequest, RequestCatalogSearchServiceSearchEntitlementsForUserResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogSearchServiceSearchEntitlementsForUserRequest, RequestCatalogSearchServiceSearchEntitlementsForUserResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchTasksForResources
     */
    searchTasksForResources(input: RequestCatalogSearchServiceSearchTasksForResourcesRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchTasksForResourcesRequest, RequestCatalogSearchServiceSearchTasksForResourcesResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogSearchServiceSearchTasksForResourcesRequest, RequestCatalogSearchServiceSearchTasksForResourcesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchResourceTypesPerApp
     */
    searchResourceTypesPerApp(input: RequestCatalogSearchServiceSearchResourceTypesPerAppRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchResourceTypesPerAppRequest, RequestCatalogSearchServiceSearchResourceTypesPerAppResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogSearchServiceSearchResourceTypesPerAppRequest, RequestCatalogSearchServiceSearchResourceTypesPerAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAccessEntitlementsPerApp
     */
    searchAccessEntitlementsPerApp(input: RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest, RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest, RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchRequestCatalogs
     */
    searchRequestCatalogs(input: SearchRequestCatalogsRequest, options?: RpcOptions): UnaryCall<SearchRequestCatalogsRequest, SearchRequestCatalogsResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchRequestCatalogsRequest, SearchRequestCatalogsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchRequestCatalogsWithEnrollmentCounts
     */
    searchRequestCatalogsWithEnrollmentCounts(input: SearchRequestCatalogsWithEnrollmentCountsRequest, options?: RpcOptions): UnaryCall<SearchRequestCatalogsWithEnrollmentCountsRequest, SearchRequestCatalogsWithEnrollmentCountsResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchRequestCatalogsWithEnrollmentCountsRequest, SearchRequestCatalogsWithEnrollmentCountsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppEntitlementsWithRequestCatalogs
     */
    searchAppEntitlementsWithRequestCatalogs(input: SearchAppEntitlementsWithRequestCatalogsRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementsWithRequestCatalogsRequest, SearchAppEntitlementsWithRequestCatalogsResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppEntitlementsWithRequestCatalogsRequest, SearchAppEntitlementsWithRequestCatalogsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAppEntitlementWithRequestCatalogs
     */
    getAppEntitlementWithRequestCatalogs(input: GetAppEntitlementWithRequestCatalogsRequest, options?: RpcOptions): UnaryCall<GetAppEntitlementWithRequestCatalogsRequest, GetAppEntitlementWithRequestCatalogsResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAppEntitlementWithRequestCatalogsRequest, GetAppEntitlementWithRequestCatalogsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchResourcesPerApp
     */
    searchResourcesPerApp(input: RequestCatalogSearchServiceSearchResourcesPerAppRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchResourcesPerAppRequest, RequestCatalogSearchServiceSearchResourcesPerAppResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogSearchServiceSearchResourcesPerAppRequest, RequestCatalogSearchServiceSearchResourcesPerAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchBrowsableApps
     */
    searchBrowsableApps(input: RequestCatalogSearchServiceSearchBrowsableAppsRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchBrowsableAppsRequest, RequestCatalogSearchServiceSearchBrowsableAppsResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogSearchServiceSearchBrowsableAppsRequest, RequestCatalogSearchServiceSearchBrowsableAppsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchBrowsableAppResources
     */
    searchBrowsableAppResources(input: RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest, RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest, RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppResourcesCount
     */
    searchAppResourcesCount(input: RequestCatalogSearchServiceSearchAppResourcesCountRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchAppResourcesCountRequest, RequestCatalogSearchServiceSearchAppResourcesCountResponse> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogSearchServiceSearchAppResourcesCountRequest, RequestCatalogSearchServiceSearchAppResourcesCountResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ParseAccessRequestToken
     */
    parseAccessRequestToken(input: AccessRequestUrlManagerServiceRequest, options?: RpcOptions): UnaryCall<AccessRequestUrlManagerServiceRequest, AccessRequestUrlManagerServiceResponse> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessRequestUrlManagerServiceRequest, AccessRequestUrlManagerServiceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GenerateAccessRequestToken
     */
    generateAccessRequestToken(input: AccessRequestUrlManagerServiceGenerateRequest, options?: RpcOptions): UnaryCall<AccessRequestUrlManagerServiceGenerateRequest, AccessRequestUrlManagerServiceGenerateResponse> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessRequestUrlManagerServiceGenerateRequest, AccessRequestUrlManagerServiceGenerateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppEntitlementsInCatalog
     */
    searchAppEntitlementsInCatalog(input: SearchAppEntitlementsInCatalogRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementsInCatalogRequest, SearchAppEntitlementsInCatalogResponse> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppEntitlementsInCatalogRequest, SearchAppEntitlementsInCatalogResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchRemovedUsers
     */
    searchRemovedUsers(input: SearchRemovedUsersRequest, options?: RpcOptions): UnaryCall<SearchRemovedUsersRequest, SearchRemovedUsersResponse> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchRemovedUsersRequest, SearchRemovedUsersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountUsersLosingMembership
     */
    countUsersLosingMembership(input: CountUsersLosingMembershipRequest, options?: RpcOptions): UnaryCall<CountUsersLosingMembershipRequest, CountUsersLosingMembershipResponse> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<CountUsersLosingMembershipRequest, CountUsersLosingMembershipResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSearchTerms
     */
    getSearchTerms(input: AppEntitlementsInCatalogTermsRequest, options?: RpcOptions): UnaryCall<AppEntitlementsInCatalogTermsRequest, AppEntitlementsInCatalogTermsResponse> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppEntitlementsInCatalogTermsRequest, AppEntitlementsInCatalogTermsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchRequestCatalogBundles
     */
    searchRequestCatalogBundles(input: SearchRequestCatalogBundlesRequest, options?: RpcOptions): UnaryCall<SearchRequestCatalogBundlesRequest, SearchRequestCatalogBundlesResponse> {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchRequestCatalogBundlesRequest, SearchRequestCatalogBundlesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppResourcesInCatalog
     */
    searchAppResourcesInCatalog(input: SearchAppResourcesInCatalogRequest, options?: RpcOptions): UnaryCall<SearchAppResourcesInCatalogRequest, SearchAppResourcesInCatalogResponse> {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppResourcesInCatalogRequest, SearchAppResourcesInCatalogResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchBrowsableAppsInBundle
     */
    searchBrowsableAppsInBundle(input: RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest, RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse> {
        const method = this.methods[25], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest, RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListBrowsableAppsInBundle
     */
    listBrowsableAppsInBundle(input: RequestCatalogSearchServiceListBrowsableAppsInBundleRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceListBrowsableAppsInBundleRequest, RequestCatalogSearchServiceListBrowsableAppsInBundleResponse> {
        const method = this.methods[26], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogSearchServiceListBrowsableAppsInBundleRequest, RequestCatalogSearchServiceListBrowsableAppsInBundleResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchCatalogEnrollmentsCount
     */
    searchCatalogEnrollmentsCount(input: RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest, RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse> {
        const method = this.methods[27], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest, RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchBrowsableAppEntitlementsCount
     */
    searchBrowsableAppEntitlementsCount(input: RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest, RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse> {
        const method = this.methods[28], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest, RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchCatalogEntitlementCountByApp
     */
    searchCatalogEntitlementCountByApp(input: RequestCatalogSearchServiceEntitlementCountByAppRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceEntitlementCountByAppRequest, RequestCatalogSearchServiceEntitlementCountByAppResponse> {
        const method = this.methods[29], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogSearchServiceEntitlementCountByAppRequest, RequestCatalogSearchServiceEntitlementCountByAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchCatalogAccessEntitlements
     */
    searchCatalogAccessEntitlements(input: RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest, options?: RpcOptions): UnaryCall<RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest, RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse> {
        const method = this.methods[30], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest, RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse>("unary", this._transport, method, opt, input);
    }
}
